export default {
    excess: 'Responsabilité excédentaire',
    security: 'Dépôt de garantie',
    fuel_policy: 'Politique de carburant',
    like_for_like: 'Équivalent à équivalent',
    full_to_full: 'Plein à plein',
    mileage: 'Kilométrage : {mileage} miles par location',
    unlimited_mileage: 'Kilométrage illimité',
    non_refundable: 'Non remboursable',
    free_cancellation_until: "Annulation gratuite jusqu'au {date}",
    cancellation_with_terms: 'Annulation {0} conformément aux ',
    t_c_text: 'C&Cs',
    two_free_extras: 'Deux extras gratuits à la collecte',
    glass_tyres_covered: 'Vitres et pneus couverts',
    spec_fuel_petrol: 'essence',
    spec_fuel_petrol_diesel: 'essence/diesel',
};
